import { defineStore } from 'pinia'
import { store } from '../index'
import { apiRegister, routesApi, apiLogin } from '@/api/login'
import { UserLoginType, ErpjumpLoginType } from '@/api/login/types'
import { useStorage } from '@/hooks/web/useStorage'
import { usePermissionStore } from '@/store/modules/permission'
import { RouteRecordRaw } from 'vue-router'
import router from '@/router'
import ArmsRum from '@/baseConfig/arms'
const { getStorage, setStorage, removeStorage } = useStorage("localStorage")

const permissionStore = usePermissionStore()

export interface UserState {
  userInfo: UserInfoTypes
}

export const useUserStore = defineStore('userInfo', {
  state: (): UserState => ({
    userInfo: getStorage('userInfo')
  }),
  getters: {
    getUserInfo(): UserInfoTypes {
      return this.userInfo
    }
  },
  actions: {
    // 用户登录
    login(data?: UserLoginType | ErpjumpLoginType): Promise<unknown> {
      return new Promise<void>((resolve, reject) => {
        // 注册用户
        apiLogin(data)
          .then(async(res) => {
            if (res.code !== 0) {
              reject(res.msg)
              return
            }
            await this.setUserInfo(res.data)
            await this.generateRoutes()
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    // 用户注册
    register(data?: UserLoginType): Promise<unknown> {
      return new Promise<void>((resolve, reject) => {
        // 注册用户
        apiRegister(data)
          .then(async(res) => {
            await this.setUserInfo(res.data)
            await this.generateRoutes()
            resolve(res.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    // 保存用户状态
    setUserInfo(data?: UserInfoTypes) {
      if (data && data.token) {
        this.userInfo = data;
        ArmsRum.setConfig('user', {
					tags: `token: ${data?.token}`,
					name: `username:${data?.realName || data?.userName}`
				});
        setStorage('userInfo', this.userInfo)
      } else {
        this.userInfo = {}
        removeStorage('userInfo')
      }
    },

    // 构建路由并跳转首页
    async generateRoutes() {
      const res = await routesApi({})

      res.data.push({
        'menuType': 1,
        'path': '/config',
        'component': '#',
        'metaTitle': '设置',
        'metaIcon': 'bi:card-image',
        'children': [
          {
            'menuType': 2,
            'path': '/config/change-password',
            'component': 'views/Config/ChangePassword',
            'name': 'ChangePassword',
            'metaTitle': '修改密码',
            'hidden': true,
            'meta': {
              'title': '修改密码',
              'alwaysShow': false
            }
          }
        ],
        'meta': {
          'icon': 'bi:card-image',
          'title': '相册管理',
          'hidden': true,
          'alwaysShow': false
        }
      })

      if (res) {
        const routers = res.data.map((route) => {
          const childrenRoute = route.children || []
          childrenRoute.forEach((r) => {
            r.meta.hidden = r.hidden
          })
          return route
        })
        setStorage('roleRouters', routers)

        // 固定使用服务端方式
        await permissionStore.generateRoutes(routers).catch(() => {})

        permissionStore.getAddRouters.forEach((route) => {
          // 动态添加可访问路由表
          router.addRoute(route as RouteRecordRaw)
        })
        permissionStore.setIsAddRouters(true)
      }
    }
  }
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
